<template>
  <el-dialog :visible="visible" class="stepGuide" @close="closeGuide">
    <div class="stepGuideMain">
      <section class="d-f">
        <div class="step p-r">
          <div
            :class="[
              currentIndex == index
                ? `stepItem d-f align-c c-p top-${70 * index} active`
                : `stepItem d-f align-c c-p top-${70 * index}`,
            ]"
            v-for="(item, index) in titleList"
            :key="index"
            @click="changeIndex(index)"
          >
            <span class="icon">
              <i :class="['iconfont', 'c-fff', 'f-s-22', `${item.icon}`]"></i>
            </span>
            <span class="title">{{ item.title }}</span>
          </div>
        </div>
        <div class="stepContent m-l-75">
          <section class="p-t-30 p-r-10" v-show="currentIndex == 0">
            <div
              class="h-505"
              v-for="(item, index) in step1List"
              :key="index"
              v-show="step1Index == index"
            >
              <div class="title p-l-18 f-s-24">{{ item.title }}</div>
              <div class="info p-l-18 f-s-14 m-t-5" v-html="item.info"></div>
              <img :src="item.url" width="814" hight="404" />
            </div>
            <div class="t-c">
              <el-button
                type="primary"
                size="medium"
                round
                plain
                :disabled="step1Index == 0"
                @click="step1Pre"
              >
                上一步
              </el-button>
              <el-button type="primary" size="medium" round @click="step1Next">
                下一步 {{ step1Index + 1 }}/{{ step1List.length }}
              </el-button>
            </div>
          </section>
          <section class="p-t-30 p-r-10" v-if="currentIndex == 1">
            <div
              class="h-505"
              v-for="(item, index) in step2List"
              :key="index"
              v-show="step2Index == index"
            >
              <div class="title p-l-18 f-s-24">{{ item.title }}</div>
              <div class="info p-l-18 f-s-14 m-t-5" v-html="item.info"></div>
              <img :src="item.url" width="814" hight="404" />
            </div>
            <div class="t-c">
              <el-button
                type="primary"
                size="medium"
                round
                plain
                @click="step2Pre"
              >
                上一步
              </el-button>
              <el-button type="primary" size="medium" round @click="step2Next">
                下一步 {{ step2Index + 1 }}/{{ step2List.length }}
              </el-button>
            </div>
          </section>
          <section class="p-t-30 p-r-10" v-if="currentIndex == 2">
            <div
              class="h-505"
              v-for="(item, index) in step3List"
              :key="index"
              v-show="step3Index == index"
            >
              <div class="title p-l-18 f-s-24">{{ item.title }}</div>
              <div class="info p-l-18 f-s-14 m-t-5" v-html="item.info"></div>
              <img :src="item.url" width="814" hight="404" />
            </div>
            <div class="t-c">
              <el-button
                type="primary"
                size="medium"
                round
                plain
                @click="step3Pre"
              >
                上一步
              </el-button>
              <el-button type="primary" size="medium" round @click="step3Next">
                下一步 {{ step3Index + 1 }}/{{ step3List.length }}
              </el-button>
            </div>
          </section>
          <section class="p-t-30 p-r-10" v-if="currentIndex == 3">
            <div
              class="h-505"
              v-for="(item, index) in step4List"
              :key="index"
              v-show="step4Index == index"
            >
              <div class="title p-l-18 f-s-24">{{ item.title }}</div>
              <div class="info p-l-18 f-s-14 m-t-5" v-html="item.info"></div>
              <div class="info p-l-18 f-s-14 m-t-5" v-html="item.info1"></div>
              <div class="info p-l-18 f-s-14 m-t-5" v-html="item.info2"></div>
              <img :src="item.url" width="814" hight="354" />
            </div>
            <div class="t-c">
              <el-button
                type="primary"
                size="medium"
                round
                plain
                @click="step4Pre"
              >
                上一步
              </el-button>
              <el-button type="primary" size="medium" round @click="step4Next">
                {{ step4Index + 1 == step4List.length ? '完成' : '下一步' }}
                {{ step4Index + 1 }}/{{ step4List.length }}
              </el-button>
            </div>
          </section>
        </div>
      </section>
    </div>
  </el-dialog>
</template>
<script>
export default {
  props: ['visible'],
  data() {
    return {
      titleList: [
        {
          icon: 'icon-lingqu',
          title: '领取',
        },
        {
          icon: 'icon-chuli',
          title: '处理',
        },
        {
          icon: 'icon-jiancha',
          title: '检查',
        },
        {
          icon: 'icon-tijiao',
          title: '提交',
        },
      ],
      currentIndex: 0,
      step1List: [
        {
          title: '配置工作时间和产能：',
          info: '<div> ◆配置工作时间和产能，更好的获得系统派发的订单，无需领取，系统自动抢单；</div>',
          url: require('../../../image/guide/step1-1.png'),
        },
        {
          title: '质控任务来源1：',
          info: ' <div>◆ 系统推送的订单：点击<span class="f-w-600">【质控列表】</span>-<span class="f-w-600">【待领取】</span>页签，进行原稿<span class="f-w-600">【预览】</span>；</div>',
          url: require('../../../image/guide/step1-2.png'),
        },
        {
          title: '质控任务来源1：',
          info: '<div>◆ 领取前<span class="f-w-600">【预览】</span>原稿和<span class="f-w-600">【项目公告】</span>，确保能胜任此项目；</div>',
          url: require('../../../image/guide/step1-3.png'),
        },
        {
          title: '质控任务来源2：',
          info: '<div>◆ 系统派发的订单：点击<span class="f-w-600">【质控列表】</span>-<span class="f-w-600">【进行中】</span>页签，点击<span class="f-w-600">【详情】</span>进行<span class="f-w-600">【原稿】</span>预览和<span class="f-w-600">【项目公告】</span>查看；</div>',
          url: require('../../../image/guide/step1-4.png'),
        },
        {
          title: '质控任务来源2：',
          info: '<div>◆ 系统派发的订单：点击<span class="f-w-600">【质控列表】</span>-<span class="f-w-600">【进行中】</span>页签，点击<span class="f-w-600">【详情】</span>进行<span class="f-w-600">【原稿】</span>预览和<span class="f-w-600">【项目公告】</span>查看；</div>',
          url: require('../../../image/guide/step1-5.png'),
        },
      ],
      step1Index: 0,
      step2List: [
        {
          title: '操作小技巧：学会筛选',
          info: '<div>◆ 单人质控任务：筛选未处理的句子；</div>',
          url: require('../../../image/guide/step2-1.png'),
        },
        {
          title: '操作小技巧：学会筛选',
          info: '<div>◆ 多人质控任务：筛选要处理的任务，检查每个任务的完成情况；</div>',
          url: require('../../../image/guide/step2-2.png'),
        },
        {
          title: '操作小技巧：学会编辑译文',
          info: '<div>◆ 单击译文框，可修改译文。修改后选择一个错误类型点击后，译文保存成功；无需修改的句子可点击<span class="f-w-600">【已阅无误】</span>；</div>',
          url: require('../../../image/guide/step2-3.png'),
        },
        {
          title: '操作小技巧：如何处理译文中的占位符标记？',
          info: '<div>◆ 在译文框中，根据原文中的标签位置，将光标放置译文内容对应处，再点击原文中要插入的占位符图标即可插入成功<br/>（注：配对图标需按顺序填充，不可颠倒）</div>',
          url: require('../../../image/guide/step2-4.png'),
        },
        {
          title: '操作小技巧：学会编辑译文',
          info: '<div>◆ 合理使用系统的错误提醒：如漏译检测、低错提醒、术语一致性检查；</div>',
          url: require('../../../image/guide/step2-5.png'),
        },
        {
          title: '操作小技巧：学会使用原稿定位',
          info: '<div>◆ 点击原文句子，即可触发原稿样式的定位和预览功能；方便结合上下文进行翻译；</div>',
          url: require('../../../image/guide/step2-6.png'),
        },
        {
          title: '操作小技巧：学会使用译稿预览',
          info: '<div>◆ 点击原文句子，可选择生成译稿预览，方便整体预览译文在译稿中的样子，进行整体译稿检查；</div>',
          url: require('../../../image/guide/step2-7.png'),
        },
        {
          title: '操作小技巧：学会使用批量替换',
          info: '<div>◆ 点击批量替换译文按钮或ctrl+F (COMMAND+f)，即可搜索译文单词进行批量替换；</div>',
          url: require('../../../image/guide/step2-8.png'),
        },
      ],
      step2Index: 0,
      step3List: [
        {
          title: '操作小技巧：低错检查',
          info: '<div>◆ 根据系统检测结果，若存在错误，则直接编辑译文；若无需修改，则直接点击提交；</div>',
          url: require('../../../image/guide/step3-1.png'),
        },
        {
          title: '操作小技巧：术语检查',
          info: '<div>◆ 根据系统检测结果，若存在错误，则直接<span class="f-w-600">编辑译文</span>；若无需修改，则直接点击<span class="f-w-600">【提交】</span>；</div>',
          url: require('../../../image/guide/step3-2.png'),
        },
        {
          title: '操作小技巧：高频词一致性检测',
          info: '<div>◆ 根据系统检测结果，若存在错误，则直接<span class="f-w-600">编辑译文</span>；若无需修改，则直接点击<span class="f-w-600">【提交】</span>；</div>',
          url: require('../../../image/guide/step3-3.png'),
        },
        {
          title: '操作小技巧：高相似句一致性检测',
          info: '<div>◆ 根据系统检测结果，若存在错误，则直接<span class="f-w-600">编辑译文</span>；若无需修改，则直接点击<span class="f-w-600">【提交】</span>；</div>',
          url: require('../../../image/guide/step3-4.png'),
        },
        {
          title: '操作小技巧：关键位置句子一致性检测',
          info: '<div>◆ 根据系统检测结果，若存在错误，则直接<span class="f-w-600">编辑译文</span>；若无需修改，则直接点击<span class="f-w-600">【提交】</span>；</div>',
          url: require('../../../image/guide/step3-5.png'),
        },
      ],
      step3Index: 0,
      step4List: [
        {
          title: '快速区分提交的弹窗原因：',
          info: '<div>◆ <span class="f-w-600">子质控未完成提交时，主质控任务不能整体提交</span>，解决方案如下：</div>',
          info1:
            '<div>1.及时联系<span class="f-w-600">PM和子质控</span>，催促完成提交；</div>',
          info2:
            '<div>2.<span class="f-w-600">强行结束子质控的任务</span>，主质控来兜底未完成的部分翻译工作。</div>',
          url: require('../../../image/guide/step4-1.png'),
        },
        {
          title: '快速区分提交的弹窗原因：',
          info: '<div>◆ <span class="f-w-600">PE环节未完成时</span>，主质控任务不能整体提交，解决方案如下：</div>',
          info1:
            '<div>1.及时<span class="f-w-600">联系PM</span>，催促完成PE任务；</div>',
          info2:
            '<div>2.当剩余未翻译的PE句子较少时，可以联系<span class="f-w-600">PM结束PE环节</span>，质控自行兜底翻译。</div>',
          url: require('../../../image/guide/step4-2.png'),
        },
        {
          title: '快速区分提交的弹窗原因：',
          info: '<div>◆ 系统<span class="f-w-600">剩余未完成</span>的句子时，不能提交质控：</div>',
          info1:
            '<div>1.当系统提醒仍有<span class="f-w-600">剩余未处理</span>的句子数时，需要<span class="f-w-600">检测筛选未处理</span>的任务；</div>',
          info2:
            '<div>2.针对未处理的句子进行逐一检查，如有问题则<span class="f-w-600">修改译文</span>，如译文正确则点击<span class="f-w-600">【已阅无误】</span></div>',
          url: require('../../../image/guide/step4-3.png'),
        },
        {
          title: '快速区分提交的弹窗原因：',
          info: '<div>◆ 系统剩余未完成句子为0时，可以提交质控任务，进行智能检查环节（检查任务）：</div>',
          info1: '',
          info2: '',
          url: require('../../../image/guide/step4-4.png'),
        },
      ],
      step4Index: 0,
    };
  },
  methods: {
    closeGuide() {
      this.$emit('close-notice');
    },
    changeIndex(index) {
      this.currentIndex = index;
    },
    step1Pre() {
      if (this.step1Index == 0) {
        return;
      }
      this.step1Index--;
    },
    step1Next() {
      if (this.step1Index + 1 == this.step1List.length) {
        this.currentIndex = 1;
        return;
      }
      this.step1Index++;
    },
    step2Pre() {
      if (this.step2Index == 0) {
        this.currentIndex = 0;
        this.step1Index = this.step1List.length - 1;
        return;
      }
      this.step2Index--;
    },
    step2Next() {
      if (this.step2Index + 1 == this.step2List.length) {
        this.currentIndex = 2;
        return;
      }
      this.step2Index++;
    },
    step3Pre() {
      if (this.step3Index == 0) {
        this.currentIndex = 1;
        this.step2Index = this.step2List.length - 1;
        return;
      }
      this.step3Index--;
    },
    step3Next() {
      if (this.step3Index + 1 == this.step3List.length) {
        this.currentIndex = 3;
        return;
      }
      this.step3Index++;
    },
    step4Pre() {
      if (this.step4Index == 0) {
        this.currentIndex = 2;
        this.step3Index = this.step3List.length - 1;
        return;
      }
      this.step4Index--;
    },
    step4Next() {
      if (this.step4Index + 1 == this.step4List.length) {
        this.currentIndex = 0;
        this.step1Index = 0;
        this.step2Index = 0;
        this.step3Index = 0;
        this.step4Index = 0;
        this.$emit('close-notice');
        return;
      }
      this.step4Index++;
    },
  },
};
</script>
